var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLefte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 628,
    viewBox: "0 0 368 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -128.288,
    cy: 295.712,
    r: 321.5,
    transform: "rotate(15.5359 -128.288 295.712)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -114.418,
    cy: 297.005,
    r: 331.141,
    transform: "rotate(15.5359 -114.418 297.005)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -90.807,
    cy: 301.221,
    r: 337.188,
    transform: "rotate(15.5359 -90.807 301.221)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -57.9733,
    cy: 309.229,
    r: 344.034,
    transform: "rotate(15.5359 -57.9733 309.229)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -144.803,
    cy: 288.87,
    r: 307.822,
    transform: "rotate(15.5359 -144.803 288.87)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -158.028,
    cy: 286,
    r: 291.685,
    transform: "rotate(15.5359 -158.028 286)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: -164.942,
    cy: 282.371,
    r: 271.683,
    transform: "rotate(15.5359 -164.942 282.371)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: -180.923,
    cy: 288.165,
    r: 254.46,
    transform: "rotate(15.5359 -180.923 288.165)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: -196.118,
    cy: 286.497,
    r: 231.178,
    transform: "rotate(15.5359 -196.118 286.497)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLefte);
export default __webpack_public_path__ + "static/media/lefte.c5e896cf9f4f38dde7d711844b9d7dbc.svg";
export { ForwardRef as ReactComponent };